import React from 'react'
import { infoScreenAriaLabel } from './AriaLabelText'
import { FormattedMessage } from 'react-intl'
import { select } from 'underscore';

export const sectionData = (isUKEnable = false) => ({
  voice: {
    Summary: {
      text: (
        <p>
          <FormattedMessage
            id="resume.section.voice.summary.text"
            defaultMessage="Voice consistency is a measure to check the amount of switch between voices in your about section. Make sure that you are not switching from first person to third person or vice versa when talking about yourself."
          />
        </p>
      ),
      correct: (
        <p>
          <FormattedMessage
            id="resume.section.voice.summary.correct"
            defaultMessage="I am a Management Consultant with 8 years of experience serving telecommunications and technology clients. I am presently working at KPMG and have proven expertise in financial and data analysis."
          />
        </p>
      ),
      incorrect: (
        <p>
          <FormattedMessage
            id="resume.section.voice.summary.incorrect"
            defaultMessage="Management Consultant with 8 years experience serving telecommunications and technology clients. I am working at KPMG and have gained expertise in financial analysis and data analysis."
          />
        </p>
      ),
    },
    Experience: {
      text: (
        <p>
          <FormattedMessage
            id="resume.section.voice.experience.text"
            defaultMessage="The system identifies and evaluates narrative voice. It is advisable to write in first person instead of third person when talking about yourself as it creates a direct connect with recruiters or people visiting your profile."
          />
        </p>
      ),
      correct: (
        <p>
          <span>{String.fromCharCode(9642)} </span>
          <FormattedMessage
            id="resume.section.voice.experience.correct"
            defaultMessage={`Developed product roadmap and introduced new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to {growthType} growth of 15%`}
            values={{ growthType: isUKEnable ? "turnover" : "revenue" }}
          />
        </p>
      ),
      incorrect: (
        <p>
          <span>{String.fromCharCode(9642)} </span>
          <FormattedMessage
            id="resume.section.voice.experience.incorrect"
            defaultMessage={`Responsible for developing product roadmap and introduced new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to {growthType} growth of 15%`}
            values={{ growthType: isUKEnable ? "turnover" : "revenue" }}
          />
        </p>
      ),
    },
  },
  tenseconsistency: {
    Summary: {
      text: (
        <p>
          <FormattedMessage
            id="resume.section.tenseconsistency.summary.text"
            defaultMessage="Tense consistency is a measure to check the amount of switch between tenses in your about section. To avoid presenting a disconcerting read to the reviewer and to ensure consistency, one should write the about section without switching between tenses too much."
          />
        </p>
      ),
      correct: (
        <div>
          <p>
            <FormattedMessage
              id="resume.section.tenseconsistency.summary.correct"
              defaultMessage="As Product Manager at Google, I was responsible for developing product roadmap and introducing new product feature in collaboration with international cross-functional team. I was selected from amongst 200 employees to form 10 person strategic review team responsible for software product development, driving new product sales as well as managing relations with existing product users."
            />
          </p>
        </div>
      ),
      incorrect: (
        <div>
          <p>
            <FormattedMessage
              id="resume.section.tenseconsistency.summary.incorrect"
              defaultMessage={`As Product Manager at Google, I {was} responsible for developing product roadmap and introducing new product feature in collaboration with international cross-functional team. I {am} selected {amongstText} 200 employees to form 10 person strategic review team responsible for software product development, driving new product sales as well as managing relations with existing product users.`}
              values={{
                was: <span className="text-red">was</span>,
                am: <span className="text-red">am</span>,
                amongstText: isUKEnable ? "amongst" : "from amongst"
              }}
            />
          </p>
        </div>
      ),
    },
    Experience: {
      text: (
        <p>
          <FormattedMessage
            id="resume.section.tenseconsistency.experience.text"
            defaultMessage="Tense consistency is a measure to check the amount of switch between tenses in your experience section. To avoid presenting a disconcerting read to the reviewer and to ensure consistency, one should write the experience without switching between tenses."
          />
        </p>
      ),
      correct: (
        <div>
          <p>
            <span>{String.fromCharCode(9642)} </span>
            <FormattedMessage
              id="resume.section.tenseconsistency.experience.correct.1"
              defaultMessage={`Developed product roadmap and introduced new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to {growthType} growth of 15%`}
              values={{ growthType: isUKEnable ? "turnover" : "revenue" }}
            />
          </p>
          <p>
            <span>{String.fromCharCode(9642)} </span>
            <FormattedMessage
              id="resume.section.tenseconsistency.experience.correct.2"
              defaultMessage={`Selected {amongstText} 200 employees to form 10 person strategic review team responsible for software product development; spearheaded new product sales and managed relations with existing product users`}
              values={{ amongstText: isUKEnable ? "amongst" : "from amongst" }}
            />
          </p>
        </div>
      ),
      incorrect: (
        <div>
          <p>
            <span>{String.fromCharCode(9642)} </span>
            <FormattedMessage
              id="resume.section.tenseconsistency.experience.incorrect.1"
              defaultMessage={`{develop} product roadmap and introducing new product feature in collaboration with international cross-functional team; generate ideas to redesign product promotion strategies, leading to {growthType} growth of 15%`}
              values={{
                develop: <span className="text-red">Develop</span>,
                growthType: isUKEnable ? "turnover" : "revenue"
              }}
            />
          </p>
          <p>
            <span>{String.fromCharCode(9642)} </span>
            <FormattedMessage
              id="resume.section.tenseconsistency.experience.incorrect.2"
              defaultMessage={`{selected} {amongstText} 200 employees to form 10 person strategic review team responsible for software product development, driving new product sales as well as managing relations with existing product users`}
              values={{ 
                selected: <span className="text-red">Selected</span>,
                amongstText: isUKEnable ? "amongst" : "from amongst" 
              }}
            />
          </p>
        </div>
      ),
    },
  },
  avoidedwords: {
    Summary: {
      text: (
        <div>
          <p>
            <FormattedMessage
              id="resume.section.avoidedwords.summary.text.1"
              defaultMessage="Avoided Words include passive language, filler words, often used in a sentence such as 'successfully', 'the', 'which', 'where', and others that consume valuable space on your profile without creating much impact."
            />
          </p>
          <p>
            <FormattedMessage
              id="resume.section.avoidedwords.summary.text.2"
              defaultMessage="It may make sense to use these in some cases, so use your {judgmentText} to remove them completely or revise the sentence content, making it more concise and impactful."
              values={{ judgmentText: isUKEnable ? "judgement" : "judgment" }}
            />
          </p>
        </div>
      ),
      correct: (
        <div>
          <p>
            <FormattedMessage
              id="resume.section.avoidedwords.summary.correct"
              defaultMessage="I am a committed and competent professional with expertise in Financial Analysis and Valuation."
            />
          </p>
        </div>
      ),
      incorrect: (
        <div>
          <p>
            <FormattedMessage
              id="resume.section.avoidedwords.summary.incorrect"
              defaultMessage={`I am a {dedicated} individual and am an expert in Financial Analysis and Valuation.`}
              values={{
                dedicated: <span className="text-red">dedicated</span>,
              }}
            />
          </p>
        </div>
      ),
    },
    Experience: {
      text: (
        <div>
          <p>
            <FormattedMessage
              id="resume.section.avoidedwords.experience.text.1"
              defaultMessage="Avoided Words include passive language, filler words, often used in a sentence such as 'successfully', 'the', 'which', 'where', and others that consume valuable space on your profile without creating much impact."
            />
          </p>
          <p>
            <FormattedMessage
              id="resume.section.avoidedwords.experience.text.2"
              defaultMessage="It may make sense to use these in some cases, so use your {judgmentText} to remove them completely or revise the sentence content, making it more concise and impactful."
              values={{ judgmentText: isUKEnable ? "judgement" : "judgment" }}
            />
          </p>
        </div>
      ),
      correct: (
        <div>
          <p>
            <span>{String.fromCharCode(9642)} </span>
            <FormattedMessage
              id="resume.section.avoidedwords.experience.correct"
              defaultMessage={`Developed product roadmap in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to {growthType} growth of 15%`}
              values={{ growthType: isUKEnable ? "turnover" : "revenue" }}
            />
          </p>
        </div>
      ),
      incorrect: (
        <div>
          <p>
            <span>{String.fromCharCode(9642)} </span>
            <FormattedMessage
              id="resume.section.avoidedwords.experience.incorrect"
              defaultMessage={`Developed {the} product roadmap in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies {that} led to {growthType} growth of 15%`}
              values={{ 
                the: <span className="text-red">the</span>,
                that: <span className="text-red">that</span>,
                growthType: isUKEnable ? "turnover" : "revenue" 
              }}
            />
          </p>
        </div>
      ),
    },
  },
  verboverusage: {
    Summary: {
      text: (
        <p>
          <FormattedMessage
            id="resume.section.verboverusage.summary.text"
            defaultMessage="Using same words, again and again, makes a profile sound too repetitive, diminishing the chances of important information stand out. Each word of the profile holds a certain weight and repeating words lends a negative impression."
          />
        </p>
      ),
      correct: (
        <div>
          <p>
            <FormattedMessage
              id="resume.section.verboverusage.summary.correct"
              defaultMessage="I developed product roadmap in collaboration with international cross-functional team, generating ideas to redesign product promotion strategies. I also established and trained 10 person strategic review team responsible for product development."
            />
          </p>
        </div>
      ),
      incorrect: (
        <div>
          <p>
            <FormattedMessage
              id="resume.section.verboverusage.summary.incorrect"
              defaultMessage={`I {developed} product roadmap in collaboration with international cross-functional team, generating ideas to redesign product promotion strategies. I also {developed} and trained 10 person strategic review team responsible for product development.`}
              values={{ developed: <span className="text-red">developed</span> }}
            />
          </p>
        </div>
      ),
    },
    Experience: {
      text: (
        <p>
          <FormattedMessage
            id="resume.section.verboverusage.experience.text"
            defaultMessage="Using same words, again and again, makes a profile sound too repetitive, diminishing the chances of important information stand out. Each word of the profile holds a certain weight and repeating words lends a negative impression."
          />
        </p>
      ),
      correct: (
        <div>
          <p>
            <span>{String.fromCharCode(9642)} </span>
            <FormattedMessage
              id="resume.section.verboverusage.experience.correct.1"
              defaultMessage={`Developed product roadmap and introduced new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to {growthType} growth of 15%`}
              values={{ growthType: isUKEnable ? "turnover" : "revenue" }}
            />
          </p>
          <p>
            <span>{String.fromCharCode(9642)} </span>
            <FormattedMessage
              id="resume.section.verboverusage.experience.correct.2"
              defaultMessage={`Selected {amongstText} 200 employees to form 10 person strategic review team responsible for software product development; drove new product sales and managed relations with existing product users`}
              values={{ amongstText: isUKEnable ? "amongst" : "from amongst" }}
            />
          </p>
        </div>
      ),
      incorrect: (
        <div>
          <p>
            <span>{String.fromCharCode(9642)} </span>
            <FormattedMessage
              id="resume.section.verboverusage.experience.incorrect.1"
              defaultMessage={`{analyzedWord} past marketing data and prepared digital marketing strategies; implemented strategies to drive 25% increase in new customers`}
              values={{ analyzedWord: (
                <span className="text-red">
                  {isUKEnable ? "Analysed" : "Analyzed"}
                </span>
              )}}
            />
          </p>
          <p>
            <span>{String.fromCharCode(9642)} </span>
            <FormattedMessage
              id="resume.section.verboverusage.experience.incorrect.2"
              defaultMessage={`Compared and {analyzedWord} results from campaign and took corrective actions; provided sales data and marketing training material to new analysts, improving efficiency by 28%`}
              values={{ analyzedWord: (
                <span className="text-red">
                  {isUKEnable ? "Analysed" : "Analyzed"}
                </span>
              )}}
            />
          </p>
        </div>
      ),
    },
  },
});

export const samplesMapForInfoCategories = (isUKEnable = false, intl) => ({
  Headline: {
    sub_heading: intl.formatMessage({
      id: "aspire.samplesMapForInfoCategories.headline.sub_heading",
      defaultMessage: "Your profile needs to include certain important pieces of information that give your profile visitors an overall view of you as a professional for example, your job role, job functions, educational qualification etc. This information helps recruiters figure out if you might be the correct fit for their company.",
    }),
    slides: [
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.slide1.exp", defaultMessage: "5 yrs' experience in" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.marketing", defaultMessage: "Marketing" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.slide1.in", defaultMessage: "in" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.technology", defaultMessage: "Technology" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.slide1.industry", defaultMessage: "Industry |" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.productManager", defaultMessage: "Product Manager" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.slide1.at", defaultMessage: "at" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.apple", defaultMessage: "Apple" })}
            </span>
            , {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.slide1.skilled", defaultMessage: "skilled in" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.productMarketing", defaultMessage: "Product marketing" })}
            </span>
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.jobFunction", defaultMessage: "Job Function" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: "aspire.category.industry", defaultMessage: "Industry" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          { name: intl.formatMessage({ id: "aspire.category.jobRole", defaultMessage: "Job Role" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
          {
            name: intl.formatMessage({
              id: isUKEnable ? "aspire.category.company_uk" : "aspire.category.company",
              defaultMessage: isUKEnable ? "Company/Organisation" : "Company/Organization"
            }),
            albhabet: intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })
          },
        ],
      },
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.mba", defaultMessage: "MBA" })}
            </span>{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.finance", defaultMessage: "Finance" })}
            </span>{' '}
            &{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.strategy", defaultMessage: "Strategy" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.slide2.candidateAt", defaultMessage: "Candidate at" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.stanford", defaultMessage: "Stanford" })}
            </span>{' '}
            |{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.lookingFor", defaultMessage: "Looking for" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.slide2.internship", defaultMessage: "internship opportunities in the field of" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.E", defaultMessage: "E" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.businessDevelopment", defaultMessage: "Business Development" })}
            </span>
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.degree", defaultMessage: "Degree" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: "aspire.category.concentration", defaultMessage: "Concentration" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          { name: intl.formatMessage({ id: "aspire.category.schoolUniversity", defaultMessage: "School/University" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
          { name: intl.formatMessage({ id: "aspire.category.goalBasedKeyword", defaultMessage: "Goal Based Keyword" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" }) },
          { name: intl.formatMessage({ id: "aspire.category.jobFunction", defaultMessage: "Job Function" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.E", defaultMessage: "E" }) },
        ],
      },
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.slide3.recentGraduate", defaultMessage: "Recent graduate" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.seeking", defaultMessage: "seeking" })}
            </span>{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.investmentBanking", defaultMessage: "Investment Banking" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.slide3.internship", defaultMessage: "internship" })} |{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.president", defaultMessage: "President" })}
            </span>{' '}
            -{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.financeClub", defaultMessage: "Finance Club" })}
            </span>{' '}
            |{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.E", defaultMessage: "E" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.cfa", defaultMessage: "CFA" })}
            </span>{' '}
            |{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.assetManagement", defaultMessage: "Asset Management" })}
            </span>{' '}
            |{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.strategy", defaultMessage: "Strategy" })}
            </span>
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.goalBasedKeyword", defaultMessage: "Goal Based Keyword" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: "aspire.category.jobFunction", defaultMessage: "Job Function" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          { name: intl.formatMessage({ id: "aspire.category.positionOfResponsibility", defaultMessage: "Position of Responsibility" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
          { name: intl.formatMessage({ id: "aspire.category.clubSociety", defaultMessage: "Club/Society" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" }) },
          { name: intl.formatMessage({ id: "aspire.category.certifications", defaultMessage: "Certifications" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.E", defaultMessage: "E" }) },
        ],
      },
    ],
    static_categories: {
      left_col: [
        intl.formatMessage({ id: "aspire.category.jobRole", defaultMessage: "Job Role" }),
        intl.formatMessage({ id: "aspire.category.clubSociety", defaultMessage: "Club/Society" }),
        intl.formatMessage({ id: "aspire.category.industry", defaultMessage: "Industry" }),
        intl.formatMessage({ id: "aspire.category.degree", defaultMessage: "Degree" }),
        intl.formatMessage({ id: "aspire.category.concentration", defaultMessage: "Concentration" }),
        intl.formatMessage({ id: "aspire.category.jobFunction", defaultMessage: "Job Function" }),
      ],
      right_col: [
        intl.formatMessage({ id: "aspire.category.schoolUniversity", defaultMessage: "School/University" }),
        intl.formatMessage({ id: "aspire.category.certifications", defaultMessage: "Certifications" }),
        intl.formatMessage({ id: "aspire.category.goalBasedKeyword", defaultMessage: "Goal Based Keyword" }),
        intl.formatMessage({
          id: isUKEnable ? "aspire.category.company_uk" : "aspire.category.company",
          defaultMessage: isUKEnable ? "Company/Organisation" : "Company/Organization"
        }),
        intl.formatMessage({ id: "aspire.category.positionOfResponsibility", defaultMessage: "Position of Responsibility" }),
      ],
    },
  },
  Summary: {
    sub_heading: intl.formatMessage({
      id: "aspire.samplesMapForInfoCategories.summary.sub_heading",
      defaultMessage: "Your profile needs to include certain important pieces of information that give your profile visitors an overall view of you as a professional for example, your job role, job functions, educational qualification etc. This information helps recruiters figure out if you might be the correct fit for their company.",
    }),
    slides: [
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide1.withExp", defaultMessage: "With 8 years of experience as a" })}{' '}
            <span className="show-category">
              {intl.formatMessage({ id: "aspire.category.hrm", defaultMessage: "Human Resources Manager" })}
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
              </div>
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide1.at", defaultMessage: "at" })}{' '}
            <span className="show-category">
              {intl.formatMessage({ id: "aspire.category.goldmanSachs", defaultMessage: "Goldman Sachs" })}
              <div className="green-icon-cr cr-icon-width-small text-color-green-small">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide1.including", defaultMessage: "including 2 years of experience in" })}{' '}
            <span className="show-category">
              {intl.formatMessage({ id: "aspire.category.talentDevelopment", defaultMessage: "talent development" })}
              <div className="green-icon-cr cr-icon-width-small text-color-green-small">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide1.and", defaultMessage: "and" })}{' '}
            <span className="show-category">
              {intl.formatMessage({ id: "aspire.category.recruiting", defaultMessage: "recruiting" })}
              <div className="green-icon-cr cr-icon-width-small text-color-green-small">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
            </span>
            , {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide1.recentlyObtained", defaultMessage: "I have recently obtained a" })}{' '}
            <span className="show-category">
              {intl.formatMessage({ id: "aspire.category.profCertHR", defaultMessage: "Professional Certificate in Human Resources" })}
              <div className="green-icon-cr cr-icon-width-small text-color-green-small">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide1.andAmAiming", defaultMessage: "and am aiming to open my own HR Consultancy for providing HR solutions to a diverse and wide set of companies." })}
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.jobRole", defaultMessage: "Job Role" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          {
            name: intl.formatMessage({
              id: isUKEnable ? "aspire.category.company_uk" : "aspire.category.company",
              defaultMessage: isUKEnable ? "Company/Organisation" : "Company/Organization"
            }),
            albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })
          },
          { name: intl.formatMessage({ id: "aspire.category.jobFunction", defaultMessage: "Job Function" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
          { name: intl.formatMessage({ id: "aspire.category.certifications", defaultMessage: "Certifications" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" }) },
        ],
      },
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide2.atCollege", defaultMessage: "At College, I was the" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.chairman", defaultMessage: "Chairman" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide2.ofThe", defaultMessage: "of the" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.toastmastersClub", defaultMessage: "Toastmasters Club" })}
            </span>
            . {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide2.asChairman", defaultMessage: "As Chairman, I" })} {isUKEnable ? intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide2.organised", defaultMessage: "organised" }) : intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide2.organized", defaultMessage: "organized" })} {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide2.variousTraining", defaultMessage: "various training sessions and workshops for students. I had also participated in various international" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.competitions", defaultMessage: "Competitions" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide2.andHad", defaultMessage: "and had" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.won", defaultMessage: "won" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide2.the", defaultMessage: "the" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.firstPrize", defaultMessage: "1st prize" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide2.inTheKpmg", defaultMessage: "in the KPMG International Case" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.competition", defaultMessage: "Competition" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide2.twice", defaultMessage: "twice in a row." })}
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.positionOfResponsibility", defaultMessage: "Position of Responsibility" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: "aspire.category.clubSociety", defaultMessage: "Club/Society" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          { name: intl.formatMessage({ id: "aspire.category.competitions", defaultMessage: "Competitions" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
          { name: intl.formatMessage({ id: "aspire.category.awards", defaultMessage: "Awards" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" }) },
        ],
      },
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide3.iam", defaultMessage: "I am an" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.mba", defaultMessage: "MBA" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide3.candidateFocusing", defaultMessage: "candidate focusing on" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.finance", defaultMessage: "Finance" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide3.and", defaultMessage: "and" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.strategy", defaultMessage: "Strategy" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide3.at", defaultMessage: "at" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.harvardBusinessSchool", defaultMessage: "Harvard Business School" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide3.andHavePrior", defaultMessage: "and have prior experience of 3 years in the same field. I have always been academically inclined and graduated Summa Cum Laude from" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.cornellUniversity", defaultMessage: "Cornell University" })}
            </span>
            .
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.degree", defaultMessage: "Degree" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: "aspire.category.concentration", defaultMessage: "Concentration" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          { name: intl.formatMessage({ id: "aspire.category.schoolUniversity", defaultMessage: "School/University" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
        ],
      },
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide4.iamPresently", defaultMessage: "I am presently" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.lookingFor", defaultMessage: "looking for" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide4.opportunitiesInThe", defaultMessage: "opportunities in the" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.education", defaultMessage: "Education" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.slide4.industryAsIAlwaysFelt", defaultMessage: "Industry as I always felt that working for student development and enhancing students’ careers was my calling in life. I can be reached at" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.email", defaultMessage: "abc.jkl@gmail.com" })}
            </span>
            .
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.goalBasedKeyword", defaultMessage: "Goal Based Keyword" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: "aspire.category.industry", defaultMessage: "Industry" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          { name: intl.formatMessage({ id: "aspire.category.contactInformation", defaultMessage: "Contact Information" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
        ],
      },
    ],
    static_categories: {
      left_col: [
        intl.formatMessage({ id: "aspire.category.awards", defaultMessage: "Awards" }),
        intl.formatMessage({ id: "aspire.category.clubSociety", defaultMessage: "Club/Society" }),
        intl.formatMessage({ id: "aspire.category.jobRole", defaultMessage: "Job Role" }),
        intl.formatMessage({ id: "aspire.category.competitions", defaultMessage: "Competitions" }),
        intl.formatMessage({ id: "aspire.category.degree", defaultMessage: "Degree" }),
        intl.formatMessage({ id: "aspire.category.concentration", defaultMessage: "Concentration" }),
        intl.formatMessage({ id: "aspire.category.industry", defaultMessage: "Industry" }),
      ],
      right_col: [
        intl.formatMessage({ id: "aspire.category.jobFunction", defaultMessage: "Job Function" }),
        intl.formatMessage({ id: "aspire.category.certifications", defaultMessage: "Certifications" }),
        intl.formatMessage({ id: "aspire.category.schoolUniversity", defaultMessage: "School/University" }),
        intl.formatMessage({ id: "aspire.category.goalBasedKeyword", defaultMessage: "Goal Based Keyword" }),
        intl.formatMessage({ id: "aspire.category.contactInformation", defaultMessage: "Contact Information" }),
        intl.formatMessage({
          id: isUKEnable ? "aspire.category.company_uk" : "aspire.category.company",
          defaultMessage: isUKEnable ? "Company/Organisation" : "Company/Organization"
        }),
        intl.formatMessage({ id: "aspire.category.positionOfResponsibility", defaultMessage: "Position of Responsibility" }),
      ],
    },
  },
  Experience: {
    sub_heading: intl.formatMessage({
      id: "aspire.samplesMapForInfoCategories.experience.sub_heading",
      defaultMessage: "Your profile needs to include certain important pieces of information that give your profile visitors an overall view of you as a professional for example, your job role, job functions, educational qualification etc. This information helps recruiters figure out if you might be the correct fit for their company.",
    }),
    slides: [
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            <span className="text-normal">
              <span className="show-category-larger">
                {intl.formatMessage({ id: "aspire.category.accountingIntern", defaultMessage: "Accounting Intern" })}
                <div className="green-icon-cr cr-icon-width-small text-color-green">
                  {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
                </div>
              </span>{' '}
              -{' '}
              <span className="show-category-larger">
                {intl.formatMessage({ id: "aspire.category.accountsPayable", defaultMessage: "Accounts payable" })}
                <div className="green-icon-cr cr-icon-width-small text-color-green">
                  {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
                </div>
              </span>{' '}
              | {intl.formatMessage({ id: "aspire.category.accountsReceivable", defaultMessage: "Accounts receivables" })} | {intl.formatMessage({ id: "aspire.category.auditing", defaultMessage: "Auditing" })} {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide1.at", defaultMessage: "at" })}{' '}
              <span className="show-category-larger">
                {intl.formatMessage({ id: "aspire.category.deloitte", defaultMessage: "Deloitte" })}
                <div className="green-icon-cr cr-icon-width-small text-color-green">
                  {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
                </div>
              </span>
            </span>
            <br />
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide1.duration", defaultMessage: "Mar 2016 - May 2016" })}
            <br />
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide1.asPartOf", defaultMessage: "As part of summer internship at" })}{' '}
            <span className="show-category">
              {intl.formatMessage({ id: "aspire.category.deloitte", defaultMessage: "Deloitte" })}
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
            </span>
            , {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide1.iUndertook", defaultMessage: "I undertook the following task:" })}
            <br />- {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide1.performedMeticulous", defaultMessage: "Performed meticulous" })}{' '}
            <span className="show-category">
              {intl.formatMessage({ id: "aspire.category.accounting", defaultMessage: "accounting" })}
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide1.forCompaniesAcross", defaultMessage: "for companies across" })}{' '}
            <span className="show-category">
              {intl.formatMessage({ id: "aspire.category.healthcare", defaultMessage: "Healthcare" })}
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide1.and", defaultMessage: "and" })}{' '}
            <span className="show-category">
              {intl.formatMessage({ id: "aspire.category.technology", defaultMessage: "Technology" })}
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide1.industries", defaultMessage: "industries; processed and consolidated 100+ customer and vendor invoices, saving company close to $10,000 in interest payments" })}
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.jobRole", defaultMessage: "Job Role" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: "aspire.category.jobFunction", defaultMessage: "Job Function" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          {
            name: intl.formatMessage({
              id: isUKEnable ? "aspire.category.company_uk" : "aspire.category.company",
              defaultMessage: isUKEnable ? "Company/Organisation" : "Company/Organization"
            }),
            albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })
          },
          { name: intl.formatMessage({ id: "aspire.category.industry", defaultMessage: "Industry" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" }) },
        ],
      },
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            <span className="text-normal">
              <span className="show-category-larger">
                <div className="green-icon-cr cr-icon-width-small text-color-green">
                  {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
                </div>
                {intl.formatMessage({ id: "aspire.category.president", defaultMessage: "President" })}
              </span>{' '}
              -{' '}
              <span className="show-category-larger">
                <div className="green-icon-cr cr-icon-width-small text-color-green">
                  {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
                </div>
                {intl.formatMessage({ id: "aspire.category.marketingClub", defaultMessage: "Marketing Club" })}
              </span>{' '}
              {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide2.at", defaultMessage: "at" })}{' '}
              <span className="show-category-larger">
                <div className="green-icon-cr cr-icon-width-small text-color-green">
                  {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
                </div>
                {intl.formatMessage({ id: "aspire.category.harvardBusinessSchool", defaultMessage: "Harvard Business School" })}
              </span>
            </span>
            <br />
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide2.duration", defaultMessage: "Jan 1993 - Jan 1995" })}
            <br />
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide2.whilePursuing", defaultMessage: "While pursuing my MBA, I was President of Marketing Club and had" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.won", defaultMessage: "won" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide2.studentOfTheYear", defaultMessage: "\"Student of the Year" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.award", defaultMessage: "Award" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide2.quoteClose", defaultMessage: "\" as well as various international" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.E", defaultMessage: "E" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.competitions", defaultMessage: "Competitions" })}
            </span>
            . {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide2.iWasMajorlyResponsible", defaultMessage: "I was majorly responsible for:" })}
            <br />- {isUKEnable
              ? intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide2.organising", defaultMessage: "Organising" })
              : intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide2.organizing", defaultMessage: "Organizing" })
            } {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide2.competitionsSeminars", defaultMessage: "10+ competitions and seminars every year," })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.F", defaultMessage: "F" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.lookingFor", defaultMessage: "looking for" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide2.andInviting", defaultMessage: "and inviting industry professionals to speak at events and getting maximum student turnout" })}
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.positionOfResponsibility", defaultMessage: "Position of Responsibility" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: "aspire.category.clubSociety", defaultMessage: "Club/Society" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          { name: intl.formatMessage({ id: "aspire.category.schoolUniversity", defaultMessage: "School/University" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
          { name: intl.formatMessage({ id: "aspire.category.awards", defaultMessage: "Awards" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" }) },
          { name: intl.formatMessage({ id: "aspire.category.competitions", defaultMessage: "Competitions" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.E", defaultMessage: "E" }) },
          { name: intl.formatMessage({ id: "aspire.category.goalBasedKeyword", defaultMessage: "Goal Based Keyword" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.F", defaultMessage: "F" }) },
        ],
      },
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            <span className="text-normal">
              <span className="show-category-larger">
                <div className="green-icon-cr cr-icon-width-small text-color-green">
                  {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
                </div>
                {intl.formatMessage({ id: "aspire.category.mba", defaultMessage: "MBA" })}
              </span>{' '}
              <span className="show-category-larger">
                <div className="green-icon-cr cr-icon-width-small text-color-green">
                  {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
                </div>
                {intl.formatMessage({ id: "aspire.category.finance", defaultMessage: "Finance" })}
              </span>{' '}
              {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide3.studentAt", defaultMessage: "Student at" })}{' '}
              <span className="show-category-larger">
                <div className="green-icon-cr cr-icon-width-small text-color-green">
                  {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
                </div>
                {intl.formatMessage({ id: "aspire.category.harvardBusinessSchool", defaultMessage: "Harvard Business School" })}
              </span>
            </span>
            <br />
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide3.duration", defaultMessage: "Jan 2016 - Present" })}
            <br />
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide3.presently", defaultMessage: "Presently, I am pursuing" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.mba", defaultMessage: "MBA" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide3.in", defaultMessage: "in" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.finance", defaultMessage: "Finance" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide3.and", defaultMessage: "and" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.strategy", defaultMessage: "Strategy" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide3.at", defaultMessage: "at" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.harvardBusinessSchool", defaultMessage: "Harvard Business School" })}
            </span>
            , {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide3.graduating", defaultMessage: "graduating in 2017. Over the last 1 year, I have built skills in financial analysis and modeling, along with investment analysis and investment strategies." })}
            <br />- {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide3.received", defaultMessage: "Received" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.cfaCertification", defaultMessage: "CFA Certification" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.experience.slide3.earlier", defaultMessage: "2 months earlier; tutored batch of 100+ students in basic financial management concepts securing top of class results" })}
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.degree", defaultMessage: "Degree" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: "aspire.category.concentration", defaultMessage: "Concentration" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          { name: intl.formatMessage({ id: "aspire.category.schoolUniversity", defaultMessage: "School/University" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
          { name: intl.formatMessage({ id: "aspire.category.certifications", defaultMessage: "Certifications" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" }) },
        ],
      },
    ],
    static_categories: {
      left_col: [
        intl.formatMessage({ id: "aspire.category.awards", defaultMessage: "Awards" }),
        intl.formatMessage({ id: "aspire.category.clubSociety", defaultMessage: "Club/Society" }),
        intl.formatMessage({ id: "aspire.category.industry", defaultMessage: "Industry" }),
        intl.formatMessage({ id: "aspire.category.competitions", defaultMessage: "Competitions" }),
        intl.formatMessage({ id: "aspire.category.degree", defaultMessage: "Degree" }),
        intl.formatMessage({ id: "aspire.category.concentration", defaultMessage: "Concentration" }),
        intl.formatMessage({ id: "aspire.category.jobRole", defaultMessage: "Job Role" }),
      ],
      right_col: [
        intl.formatMessage({ id: "aspire.category.jobFunction", defaultMessage: "Job Function" }),
        intl.formatMessage({ id: "aspire.category.certifications", defaultMessage: "Certifications" }),
        intl.formatMessage({ id: "aspire.category.goalBasedKeyword", defaultMessage: "Goal Based Keyword" }),
        intl.formatMessage({ id: "aspire.category.schoolUniversity", defaultMessage: "School/University" }),
        intl.formatMessage({
          id: isUKEnable ? "aspire.category.company_uk" : "aspire.category.company",
          defaultMessage: isUKEnable ? "Company/Organisation" : "Company/Organization"
        }),
        intl.formatMessage({ id: "aspire.category.positionOfResponsibility", defaultMessage: "Position of Responsibility" }),
      ],
    },
  },
  Education: {
    sub_heading: intl.formatMessage({
      id: "aspire.samplesMapForInfoCategories.education.sub_heading",
      defaultMessage: "Your profile needs to include certain important pieces of information that give your profile visitors an overall view of you as a professional for example, your job role, job functions, educational qualification etc. This information helps recruiters figure out if you might be the correct fit for their company.",
    }),
    slides: [
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            <span className="text-normal">
              <span className="show-category-larger">
                <div className="green-icon-cr cr-icon-width-small text-color-green">
                  {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
                </div>
                {intl.formatMessage({ id: "aspire.category.londonBusinessSchool", defaultMessage: "London Business School" })}
              </span>
              <br />
              <span className="show-category-larger">
                <div className="green-icon-cr cr-icon-width-small text-color-green">
                  {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
                </div>
                {intl.formatMessage({ id: "aspire.category.mba", defaultMessage: "Master of Business Administration" })}
              </span>{' '}
              <span className="show-category-larger">
                <div className="green-icon-cr cr-icon-width-small text-color-green">
                  {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
                </div>
                {intl.formatMessage({ id: "aspire.category.mbaShort", defaultMessage: "(MBA)" })}
              </span>
              ,{' '}
              <span className="show-category-larger">
                <div className="green-icon-cr cr-icon-width-small text-color-green">
                  {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
                </div>
                {intl.formatMessage({ id: "aspire.category.finance", defaultMessage: "Finance" })}
              </span>
            </span>
            <br />
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.slide1.duration", defaultMessage: "2015 - 2017" })}
            <br />
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.slide1.activities", defaultMessage: "Activities and Societies:" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.president", defaultMessage: "President" })}
            </span>{' '}
            -{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.E", defaultMessage: "E" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.consultingClub", defaultMessage: "Consulting Club" })}
            </span>
            , {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.slide1.member", defaultMessage: "Member -" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.E", defaultMessage: "E" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.energyClub", defaultMessage: "Energy Club" })}
            </span>
            , {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.slide1.member", defaultMessage: "Member -" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.E", defaultMessage: "E" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.businessClubChinaClub", defaultMessage: "Business Club and China Club" })}
            </span>
            , {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.slide1.completed", defaultMessage: "completed" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.F", defaultMessage: "F" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.cfa", defaultMessage: "CFA" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.category.certification", defaultMessage: "Certification" })}
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.schoolUniversity", defaultMessage: "School/University" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: "aspire.category.degree", defaultMessage: "Degree" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          { name: intl.formatMessage({ id: "aspire.category.concentration", defaultMessage: "Concentration" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
          { name: intl.formatMessage({ id: "aspire.category.positionOfResponsibility", defaultMessage: "Position of Responsibility" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" }) },
          { name: intl.formatMessage({ id: "aspire.category.clubSociety", defaultMessage: "Club/Society" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.E", defaultMessage: "E" }) },
          { name: intl.formatMessage({ id: "aspire.category.certifications", defaultMessage: "Certifications" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.F", defaultMessage: "F" }) },
        ],
      },
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            <span className="text-normal">
              <span className="show-category-larger">
                <div className="green-icon-cr cr-icon-width-small text-color-green">
                  {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
                </div>
                {intl.formatMessage({ id: "aspire.category.harvardBusinessSchool", defaultMessage: "Harvard Business School" })}
              </span>
              <br />
              <span className="show-category-larger">
                <div className="green-icon-cr cr-icon-width-small text-color-green">
                  {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
                </div>
                {intl.formatMessage({ id: "aspire.category.mba", defaultMessage: "Master of Business Administration" })}
              </span>{' '}
              <span className="show-category-larger">
                <div className="green-icon-cr cr-icon-width-small text-color-green">
                  {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
                </div>
                {intl.formatMessage({ id: "aspire.category.mbaShort", defaultMessage: "(MBA)" })}
              </span>
              ,{' '}
              <span className="show-category-larger">
                <div className="green-icon-cr cr-icon-width-small text-color-green">
                  {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
                </div>
                {intl.formatMessage({ id: "aspire.category.finance", defaultMessage: "Finance" })}
              </span>
            </span>
            <br />
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.slide2.duration", defaultMessage: "2015 - 2017" })}
            <br />
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.slide2.activities", defaultMessage: "Activities and Societies: Member of" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.privateEquityClub", defaultMessage: "Private Equity and Venture Capital Club" })}
            </span>
            ,{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.E", defaultMessage: "E" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.winner", defaultMessage: "Winner" })}
            </span>{' '}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.slide2.of", defaultMessage: "of" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.F", defaultMessage: "F" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.caseStudyCompetition", defaultMessage: "Case Study Competition" })}
            </span>
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.schoolUniversity", defaultMessage: "School/University" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: "aspire.category.degree", defaultMessage: "Degree" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          { name: intl.formatMessage({ id: "aspire.category.concentration", defaultMessage: "Concentration" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
          { name: intl.formatMessage({ id: "aspire.category.clubSociety", defaultMessage: "Club/Society" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" }) },
          { name: intl.formatMessage({ id: "aspire.category.awards", defaultMessage: "Awards" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.E", defaultMessage: "E" }) },
          { name: intl.formatMessage({ id: "aspire.category.competitions", defaultMessage: "Competitions" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.F", defaultMessage: "F" }) },
        ],
      },
    ],
    static_categories: {
      left_col: [
        intl.formatMessage({ id: "aspire.category.awards", defaultMessage: "Awards" }),
        intl.formatMessage({ id: "aspire.category.clubSociety", defaultMessage: "Club/Society" }),
        intl.formatMessage({ id: "aspire.category.competitions", defaultMessage: "Competitions" }),
        intl.formatMessage({ id: "aspire.category.degree", defaultMessage: "Degree" }),
      ],
      right_col: [
        intl.formatMessage({ id: "aspire.category.concentration", defaultMessage: "Concentration" }),
        intl.formatMessage({ id: "aspire.category.schoolUniversity", defaultMessage: "School/University" }),
        intl.formatMessage({ id: "aspire.category.certifications", defaultMessage: "Certifications" }),
        intl.formatMessage({ id: "aspire.category.positionOfResponsibility", defaultMessage: "Position of Responsibility" }),
      ],
    },
  },
})

export const samplesMapForInfoCategoriesMofo = (isUKEnable = false, intl) => ({
  Headline: {
    sub_heading: intl.formatMessage({
      id: "aspire.samplesMapForInfoCategories.headline.sub_heading",
      defaultMessage: "Your profile needs to include certain important pieces of information that give your profile visitors an overall view of you as a professional for example, your job role, job functions, educational qualification etc. This information helps recruiters figure out if you might be the correct fit for their company.",
    }),
    slides: [
      // Example 1
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.example1.prefix.mofo", defaultMessage: "10+ years’ experience in" })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.space1.mofo", defaultMessage: " " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.corporateLaw.mofo", defaultMessage: "Corporate Law" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.space2.mofo", defaultMessage: " " })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.example1.in.mofo", defaultMessage: "in" })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.space3.mofo", defaultMessage: " " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.technologyFinancial.mofo", defaultMessage: "Technology & Financial Services" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.bar1.mofo", defaultMessage: " | " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.seniorCorporateCounsel.mofo", defaultMessage: "Senior Corporate Counsel" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.space4.mofo", defaultMessage: " " })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.example1.at.mofo", defaultMessage: "at" })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.space5.mofo", defaultMessage: " " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.globalSaasCompany.mofo", defaultMessage: "Global SaaS Company" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.comma1.mofo", defaultMessage: "," })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.space6.mofo", defaultMessage: " " })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.example1.skillsIntro.mofo", defaultMessage: "skilled in" })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.space7.mofo", defaultMessage: " " })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.example1.skills.mofo", defaultMessage: "M&A, Commercial Contracts & Governance" })}
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.jobFunction", defaultMessage: "Job Function" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: "aspire.category.industry", defaultMessage: "Industry" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          { name: intl.formatMessage({ id: "aspire.category.jobRole", defaultMessage: "Job Role" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
          { name: intl.formatMessage({
            id: isUKEnable ? "aspire.category.company_uk" : "aspire.category.company",
            defaultMessage: isUKEnable ? "Company/Organisation" : "Company/Organization"
          }), albhabet: intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" }) },
        ],
      },
      // Example 2
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.jurisDoctor.mofo", defaultMessage: "Juris Doctor (JD)" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.bar2.mofo", defaultMessage: " | " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.corporateSecuritiesLaw.mofo", defaultMessage: "Corporate & Securities Law" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.bar3.mofo", defaultMessage: " | " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.stanfordLawSchool.mofo", defaultMessage: "Stanford Law School" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.bar4.mofo", defaultMessage: " | " })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.example2.exploring.mofo", defaultMessage: "Exploring" })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.space8.mofo", defaultMessage: " " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.seniorInHouseRoles.mofo", defaultMessage: "senior in-house counsel roles" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.space9.mofo", defaultMessage: " " })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.example2.in.mofo", defaultMessage: "in" })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.space10.mofo", defaultMessage: " " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.E", defaultMessage: "E" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.corporateGovCompliance.mofo", defaultMessage: "Corporate Governance & Regulatory Compliance" })}
            </span>
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.degree", defaultMessage: "Degree" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: "aspire.category.concentration", defaultMessage: "Concentration" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          { name: intl.formatMessage({ id: "aspire.category.schoolUniversity", defaultMessage: "School/University" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
          { name: intl.formatMessage({ id: "aspire.category.goalBasedKeyword", defaultMessage: "Goal Based Keyword" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" }) },
          { name: intl.formatMessage({ id: "aspire.category.jobFunction", defaultMessage: "Job Function" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.E", defaultMessage: "E" }) },
        ],
      },
      // Example 3
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.example3.prefix.mofo", defaultMessage: "Experienced attorney seeking" })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.space11.mofo", defaultMessage: " " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.generalCounselCLO.mofo", defaultMessage: "General Counsel / Chief Legal Officer opportunities" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.bar5.mofo", defaultMessage: " | " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.corporateGovCompliance.mofo", defaultMessage: "Corporate Governance & Compliance" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.bar6.mofo", defaultMessage: " | " })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.example3.former.mofo", defaultMessage: "Former" })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.space12.mofo", defaultMessage: " " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.boardAdvisorLegal.mofo", defaultMessage: "Board {isUKEnable, select, true {Adviser} other {Advisor}} – Legal Affairs" }, { isUKEnable: isUKEnable ? 'true' : 'false' })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.bar7.mofo", defaultMessage: " | " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.abaMember.mofo", defaultMessage: "ABA Member" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.headline.bar8.mofo", defaultMessage: " | " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.E", defaultMessage: "E" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.cippusCert.mofo", defaultMessage: "CIPP/US Certified" })}
            </span>
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.goalBasedKeyword", defaultMessage: "Goal Based Keyword" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: "aspire.category.jobFunction", defaultMessage: "Job Function" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          { name: intl.formatMessage({ id: "aspire.category.positionOfResponsibility", defaultMessage: "Position of Responsibility" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
          { name: intl.formatMessage({ id: "aspire.category.clubSociety", defaultMessage: "Club/Society" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" }) },
          { name: intl.formatMessage({ id: "aspire.category.certifications", defaultMessage: "Certifications" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.E", defaultMessage: "E" }) },
        ],
      }
    ],
    static_categories: {
      left_col: [
        intl.formatMessage({ id: "aspire.category.jobRole", defaultMessage: "Job Role" }),
        intl.formatMessage({ id: "aspire.category.clubSociety", defaultMessage: "Club/Society" }),
        intl.formatMessage({ id: "aspire.category.industry", defaultMessage: "Industry" }),
        intl.formatMessage({ id: "aspire.category.degree", defaultMessage: "Degree" }),
        intl.formatMessage({ id: "aspire.category.concentration", defaultMessage: "Concentration" }),
        intl.formatMessage({ id: "aspire.category.jobFunction", defaultMessage: "Job Function" }),
      ],
      right_col: [
        intl.formatMessage({ id: "aspire.category.schoolUniversity", defaultMessage: "School/University" }),
        intl.formatMessage({ id: "aspire.category.certifications", defaultMessage: "Certifications" }),
        intl.formatMessage({ id: "aspire.category.goalBasedKeyword", defaultMessage: "Goal Based Keyword" }),
        intl.formatMessage({
          id: isUKEnable ? "aspire.category.company_uk" : "aspire.category.company",
          defaultMessage: isUKEnable ? "Company/Organisation" : "Company/Organization"
        }),
        intl.formatMessage({ id: "aspire.category.positionOfResponsibility", defaultMessage: "Position of Responsibility" }),
      ]
    }
  },

  Summary: {
    sub_heading: intl.formatMessage({
      id: "aspire.samplesMapForInfoCategories.summary.sub_heading",
      defaultMessage: "Your profile needs to include certain important pieces of information that give your profile visitors an overall view of you as a professional for example, your job role, job functions, educational qualification etc. This information helps recruiters figure out if you might be the correct fit for their company.",
    }),
    slides: [
      // Example 1
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example1.prefix.mofo", defaultMessage: "With 10+ years of experience as" })}{' '}
            <span className="show-category">
              {intl.formatMessage({ id: "aspire.category.jobRole.seniorCorporateCounsel.mofo", defaultMessage: "Senior Corporate Counsel" })}
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
              </div>
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example1.at.mofo", defaultMessage: " at " })}
            <span className="show-category">
              {intl.formatMessage({ id: "aspire.category.company.globalFinancialServices.mofo", defaultMessage: "Global Financial Services Company" })}
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example1.comma1.mofo", defaultMessage: "," })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example1.incExpIn.mofo", defaultMessage: " including extensive experience in " })}
            <span className="show-category">
              {intl.formatMessage({ id: "aspire.category.jobFunction.corporateGovernanceCommercialLaw.mofo", defaultMessage: "Corporate Governance / Commercial Law" })}
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example1.comma2.mofo", defaultMessage: "," })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example1.recentlyObtained.mofo", defaultMessage: " I recently obtained the " })}
            <span className="show-category">
              {intl.formatMessage({ id: "aspire.category.certifications.cippus.mofo", defaultMessage: "CIPP/US" })}
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
            </span>
            {intl.formatMessage({
              id: "aspire.samplesMapForInfoCategories.summary.example1.certificationAndNow.mofo",
              defaultMessage: " certification and am now exploring broader in-house leadership opportunities."
            })}
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.jobRole", defaultMessage: "Job Role" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: isUKEnable ? "aspire.category.company_uk" : "aspire.category.company", defaultMessage: isUKEnable ? "Company/Organisation" : "Company/Organization" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          { name: intl.formatMessage({ id: "aspire.category.jobFunction", defaultMessage: "Job Function" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
          { name: intl.formatMessage({ id: "aspire.category.certifications", defaultMessage: "Certifications" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" }) }
        ]
      },
      // Example 2
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example2.prefix.mofo", defaultMessage: "During my legal career, I have served as" })}{' '}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.positionOfResponsibility.practiceGroupLead.mofo", defaultMessage: "Practice Group Lead" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example2.withinFirm.mofo", defaultMessage: " within my firm and have been an active member of the " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.clubSociety.abamember.mofo", defaultMessage: "American Bar Association (ABA)" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example2.participated.mofo", defaultMessage: ". I have participated in and spoken at multiple " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.competitions.nationalLegalConf.mofo", defaultMessage: "national legal conferences / forums" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example2.comma.mofo", defaultMessage: "," })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example2.andWasRecognized.mofo", defaultMessage: " and was recognized with the " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.awards.firmExcellence.mofo", defaultMessage: "Firm Excellence Award" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example2.forClientService.mofo", defaultMessage: " for Client Service." })}
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.positionOfResponsibility", defaultMessage: "Position of Responsibility" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: "aspire.category.clubSociety", defaultMessage: "Club/Society" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          { name: intl.formatMessage({ id: "aspire.category.competitions", defaultMessage: "Competitions" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
          { name: intl.formatMessage({ id: "aspire.category.awards", defaultMessage: "Awards" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" }) },
        ]
      },
      // Example 3
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example3.prefix.mofo", defaultMessage: "I hold a" })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.space.mofo", defaultMessage: " " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.degree.jurisDoctor.mofo", defaultMessage: "Juris Doctor (JD)" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example3.withAConcIn.mofo", defaultMessage: " with a concentration in " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.concentration.corporateSecuritiesLaw.mofo", defaultMessage: "Corporate & Securities Law" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example3.from.mofo", defaultMessage: " from " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.schoolUniversity.harvardLaw.mofo", defaultMessage: "Harvard Law School" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example3.rest.mofo", defaultMessage: ", and have over 8 years of post-qualification experience advising public and private companies on complex legal matters." })}
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.degree", defaultMessage: "Degree" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: "aspire.category.concentration", defaultMessage: "Concentration" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          { name: intl.formatMessage({ id: "aspire.category.schoolUniversity", defaultMessage: "School/University" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
        ]
      },
      // Example 4
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example4.prefix.mofo", defaultMessage: "Currently seeking" })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.space.mofo", defaultMessage: " " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.goalBasedKeyword.seniorInHouse.mofo", defaultMessage: "Senior In-House Counsel / Legal Director" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example4.oppWithinThe.mofo", defaultMessage: " opportunities within the " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.industry.technologyFinancial.mofo", defaultMessage: "Technology & Financial Services" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example4.sectorsOpen.mofo", defaultMessage: " sectors. Open to confidential discussions at " })}
            <span className="show-category">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.contactInformation.email.mofo", defaultMessage: "firstname.lastname@email.com" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.summary.example4.endingDot.mofo", defaultMessage: "." })}
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.goalBasedKeyword", defaultMessage: "Goal Based Keyword" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: "aspire.category.industry", defaultMessage: "Industry" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          { name: intl.formatMessage({ id: "aspire.category.contactInformation", defaultMessage: "Contact Information" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
        ]
      },
    ],
    static_categories: {
      left_col: [
        intl.formatMessage({ id: "aspire.category.awards", defaultMessage: "Awards" }),
        intl.formatMessage({ id: "aspire.category.clubSociety", defaultMessage: "Club/Society" }),
        intl.formatMessage({ id: "aspire.category.jobRole", defaultMessage: "Job Role" }),
        intl.formatMessage({ id: "aspire.category.competitions", defaultMessage: "Competitions" }),
        intl.formatMessage({ id: "aspire.category.degree", defaultMessage: "Degree" }),
        intl.formatMessage({ id: "aspire.category.concentration", defaultMessage: "Concentration" }),
        intl.formatMessage({ id: "aspire.category.industry", defaultMessage: "Industry" }),
      ],
      right_col: [
        intl.formatMessage({ id: "aspire.category.jobFunction", defaultMessage: "Job Function" }),
        intl.formatMessage({ id: "aspire.category.certifications", defaultMessage: "Certifications" }),
        intl.formatMessage({ id: "aspire.category.schoolUniversity", defaultMessage: "School/University" }),
        intl.formatMessage({ id: "aspire.category.goalBasedKeyword", defaultMessage: "Goal Based Keyword" }),
        intl.formatMessage({ id: "aspire.category.contactInformation", defaultMessage: "Contact Information" }),
        intl.formatMessage({
          id: isUKEnable ? "aspire.category.company_uk" : "aspire.category.company",
          defaultMessage: isUKEnable ? "Company/Organisation" : "Company/Organization"
        }),
        intl.formatMessage({ id: "aspire.category.positionOfResponsibility", defaultMessage: "Position of Responsibility" }),
      ],
    }
  },

  Experience: {
    sub_heading: intl.formatMessage({
      id: "aspire.samplesMapForInfoCategories.experience.sub_heading",
      defaultMessage: "Your profile needs to include certain important pieces of information that give your profile visitors an overall view of you as a professional for example, your job role, job functions, educational qualification etc. This information helps recruiters figure out if you might be the correct fit for their company."
    }),
    slides: [
      // Example 1
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            {/* Header */}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.A",defaultMessage:"A"})}
              </div>
              {intl.formatMessage({id:"aspire.category.jobRole.seniorCorporateCounsel.mofo",defaultMessage:"Senior Corporate Counsel"})}
            </span>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.dash.mofo",defaultMessage:" – "})}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.B",defaultMessage:"B"})}
              </div>
              {intl.formatMessage({id:"aspire.category.jobFunction.corporateGovernanceCommercialLaw.mofo",defaultMessage:"Corporate Governance & Commercial Law"})}
            </span>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.bar.mofo",defaultMessage:" | "})}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.C",defaultMessage:"C"})}
              </div>
              {intl.formatMessage({id:"aspire.category.company.globalTechnologyCompany.mofo",defaultMessage:"Global Technology Company"})}
            </span>
            <br/>
            {/* Bullets */}
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.bulletSymbol.mofo",defaultMessage:"•"})}
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example1.bullet1.prefix.mofo",defaultMessage:" Led legal support for "})}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.B",defaultMessage:"B"})}
              </div>
              {intl.formatMessage({id:"aspire.category.jobFunction.mnaTransactions.mofo",defaultMessage:"M&A transactions"})}
            </span>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example1.bullet1.suffix.mofo",defaultMessage:", strategic partnerships, and complex commercial agreements, advising senior leadership on risk mitigation and deal structuring."})}
            <br/>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.bulletSymbol.mofo",defaultMessage:"•"})}
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example1.bullet2.prefix.mofo",defaultMessage:" Acted as "})}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.A",defaultMessage:"A"})}
              </div>
              {intl.formatMessage({id:"aspire.category.jobRole.primaryLegalAdvisor.mofo",defaultMessage:"primary legal {isUKEnable, select, true {adviser} other {advisor}}"}, { isUKEnable: isUKEnable ? 'true' : 'false' })}
            </span>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example1.bullet2.suffix.mofo",defaultMessage:" on corporate governance, board matters, and public-company compliance, including SEC and disclosure obligations."})}
            <br/>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.bulletSymbol.mofo",defaultMessage:"•"})}
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example1.bullet3.prefix.mofo",defaultMessage:" Partnered closely with finance, product, and compliance teams to support "})}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.D",defaultMessage:"D"})}
              </div>
              {intl.formatMessage({id:"aspire.category.goalBasedKeyword.crossBorderOperations.mofo",defaultMessage:"cross-border operations"})}
            </span>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example1.bullet3.suffix.mofo",defaultMessage:" across the US, EU, and APAC."})}
          </p>
        ),
        categories: [
          { name: intl.formatMessage({id:"aspire.category.jobRole",defaultMessage:"Job Role"}), albhabet: intl.formatMessage({id:"aspire.category.marker.A",defaultMessage:"A"}) },
          { name: intl.formatMessage({id:"aspire.category.jobFunction",defaultMessage:"Job Function"}), albhabet: intl.formatMessage({id:"aspire.category.marker.B",defaultMessage:"B"}) },
          { name: intl.formatMessage({id:"aspire.category.company",defaultMessage:isUKEnable ? "Company/Organisation" : "Company/Organization"}), albhabet: intl.formatMessage({id:"aspire.category.marker.C",defaultMessage:"C"}) },
          { name: intl.formatMessage({id:"aspire.category.goalBasedKeyword",defaultMessage:"Goal Based Keyword"}), albhabet: intl.formatMessage({id:"aspire.category.marker.D",defaultMessage:"D"}) },
        ],
      },
      // Example 2
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.A",defaultMessage:"A"})}
              </div>
              {intl.formatMessage({id:"aspire.category.jobRole.seniorAssociate.mofo",defaultMessage:"Senior Associate"})}
            </span>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.dash.mofo",defaultMessage:" – "})}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.B",defaultMessage:"B"})}
              </div>
              {intl.formatMessage({id:"aspire.category.jobFunction.litRegInvCommLit.mofo",defaultMessage:"Litigation & Regulatory Investigations"})}
            </span>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.bar.mofo",defaultMessage:" | "})}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.C",defaultMessage:"C"})}
              </div>
              {intl.formatMessage({id:"aspire.category.company.internationalLawFirm.mofo",defaultMessage:"International Law Firm"})}
            </span>
            <br/>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.bulletSymbol.mofo",defaultMessage:"•"})}
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example2.bullet1.prefix.mofo",defaultMessage:" Represented multinational clients in high-stakes "})}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.B",defaultMessage:"B"})}
              </div>
              {intl.formatMessage({id:"aspire.category.jobFunction.litigation.mofo",defaultMessage:"commercial litigation"})}
            </span>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example2.bullet1.mid.mofo",defaultMessage:" and regulatory enforcement matters, including "})}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.D",defaultMessage:"D"})}
              </div>
              {intl.formatMessage({id:"aspire.category.goalBasedKeyword.crossBorderDisputes.mofo",defaultMessage:"cross-border disputes"})}
            </span>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example2.bullet1.suffix.mofo",defaultMessage:"."})}
            <br/>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.bulletSymbol.mofo",defaultMessage:"•"})}
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example2.bullet2.prefix.mofo",defaultMessage:" Conducted "})}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.B",defaultMessage:"B"})}
              </div>
              {intl.formatMessage({id:"aspire.category.jobFunction.regulatoryInvestigations.mofo",defaultMessage:"internal investigations"})}
            </span>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example2.bullet2.suffix.mofo",defaultMessage:" involving fraud, corruption, and regulatory compliance, coordinating with forensic experts and regulators."})}
            <br/>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.bulletSymbol.mofo",defaultMessage:"•"})}
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example2.bullet3.prefix.mofo",defaultMessage:" Drafted "})}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.E",defaultMessage:"E"})}
              </div>
              {intl.formatMessage({id:"aspire.category.industry.legalServices.mofo",defaultMessage:"complex pleadings, motions, and regulatory submissions"})}
            </span>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example2.bullet3.suffix.mofo",defaultMessage:" and supported trial and arbitration proceedings."})}
            <br/>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.bulletSymbol.mofo",defaultMessage:"•"})}
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example2.bullet4.mofo",defaultMessage:" Advised clients on risk exposure, settlement strategy, and compliance remediation."})}
          </p>
        ),
        categories: [
          { name: intl.formatMessage({id:"aspire.category.jobRole",defaultMessage:"Job Role"}), albhabet: intl.formatMessage({id:"aspire.category.marker.A",defaultMessage:"A"}) },
          { name: intl.formatMessage({id:"aspire.category.jobFunction",defaultMessage:"Job Function"}), albhabet: intl.formatMessage({id:"aspire.category.marker.B",defaultMessage:"B"}) },
          { name: intl.formatMessage({id:"aspire.category.company",defaultMessage:isUKEnable ? "Company/Organisation" : "Company/Organization"}), albhabet: intl.formatMessage({id:"aspire.category.marker.C",defaultMessage:"C"}) },
          { name: intl.formatMessage({id:"aspire.category.goalBasedKeyword",defaultMessage:"Goal Based Keyword"}), albhabet: intl.formatMessage({id:"aspire.category.marker.D",defaultMessage:"D"}) },
          { name: intl.formatMessage({id:"aspire.category.industry",defaultMessage:"Industry"}), albhabet: intl.formatMessage({id:"aspire.category.marker.E",defaultMessage:"E"}) },
        ],
      },
      // Example 3
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.A",defaultMessage:"A"})}
              </div>
              {intl.formatMessage({id:"aspire.category.jobRole.privacyRegCounsel.mofo",defaultMessage:"Privacy & Regulatory Counsel"})}
            </span>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.dash.mofo",defaultMessage:" – "})}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.B",defaultMessage:"B"})}
              </div>
              {intl.formatMessage({id:"aspire.category.jobFunction.dataProtectionCompliance.mofo",defaultMessage:"Data Protection & Compliance"})}
            </span>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.bar.mofo",defaultMessage:" | "})}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.C",defaultMessage:"C"})}
              </div>
              {intl.formatMessage({id:"aspire.category.company.globalFinServCompany.mofo",defaultMessage:"Global Financial Services Company"})}
            </span>
            <br/>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.bulletSymbol.mofo",defaultMessage:"•"})}
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example3.bullet1.prefix.mofo",defaultMessage:" Advised business and product teams on global data protection laws, including GDPR, CCPA, and "})}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.D",defaultMessage:"D"})}
              </div>
              {intl.formatMessage({id:"aspire.category.goalBasedKeyword.crossBorderDataTransfers.mofo",defaultMessage:"cross-border data transfers"})}
            </span>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example3.bullet1.suffix.mofo",defaultMessage:"."})}
            <br/>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.bulletSymbol.mofo",defaultMessage:"•"})}
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example3.bullet2.prefix.mofo",defaultMessage:" Designed and implemented "})}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.B",defaultMessage:"B"})}
              </div>
              {intl.formatMessage({id:"aspire.category.jobFunction.privacyByDesignFrameworks.mofo",defaultMessage:"privacy-by-design frameworks"})}
            </span>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example3.bullet2.suffix.mofo",defaultMessage:" for new products and digital initiatives."})}
            <br/>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.bulletSymbol.mofo",defaultMessage:"•"})}
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example3.bullet3.prefix.mofo",defaultMessage:" Led "})}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.B",defaultMessage:"B"})}
              </div>
              {intl.formatMessage({id:"aspire.category.jobFunction.regulatoryInteractionsAudits.mofo",defaultMessage:"regulatory interactions and audits"})}
            </span>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example3.bullet3.suffix.mofo",defaultMessage:", ensuring ongoing compliance across multiple jurisdictions."})}
            <br/>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.bulletSymbol.mofo",defaultMessage:"•"})}
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example3.bullet4.prefix.mofo",defaultMessage:" Developed "})}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({id:"aspire.category.marker.B",defaultMessage:"B"})}
              </div>
              {intl.formatMessage({id:"aspire.category.jobFunction.privacyPolicies.mofo",defaultMessage:"internal privacy policies"})}
            </span>
            {intl.formatMessage({id:"aspire.samplesMapForInfoCategories.experience.example3.bullet4.suffix.mofo",defaultMessage:", governance standards, and compliance training {isUKEnable, select, true {programmes} other {programs}}."}, { isUKEnable: isUKEnable ? 'true' : 'false' })}
          </p>
        ),
        categories: [
          { name: intl.formatMessage({id:"aspire.category.jobRole",defaultMessage:"Job Role"}), albhabet: intl.formatMessage({id:"aspire.category.marker.A",defaultMessage:"A"}) },
          { name: intl.formatMessage({id:"aspire.category.jobFunction",defaultMessage:"Job Function"}), albhabet: intl.formatMessage({id:"aspire.category.marker.B",defaultMessage:"B"}) },
          { name: intl.formatMessage({id:"aspire.category.company",defaultMessage:isUKEnable ? "Company/Organisation" : "Company/Organization"}), albhabet: intl.formatMessage({id:"aspire.category.marker.C",defaultMessage:"C"}) },
          { name: intl.formatMessage({id:"aspire.category.goalBasedKeyword",defaultMessage:"Goal Based Keyword"}), albhabet: intl.formatMessage({id:"aspire.category.marker.D",defaultMessage:"D"}) },
        ],
      }
    ],
    static_categories: {
      left_col: [
        intl.formatMessage({ id: "aspire.category.jobRole", defaultMessage: "Job Role" }),
        intl.formatMessage({ id: "aspire.category.industry", defaultMessage: "Industry" }),
        intl.formatMessage({ id: "aspire.category.goalBasedKeyword", defaultMessage: "Goal Based Keyword" }),
      ],
      right_col: [
        intl.formatMessage({ id: "aspire.category.jobFunction", defaultMessage: "Job Function" }),
        intl.formatMessage({ id: isUKEnable ? "aspire.category.company_uk" : "aspire.category.company", defaultMessage: isUKEnable ? "Company/Organisation" : "Company/Organization" }),
      ],
    },
  },

  Education: {
    sub_heading: intl.formatMessage({
      id: "aspire.samplesMapForInfoCategories.education.sub_heading",
      defaultMessage: "Your profile needs to include certain important pieces of information that give your profile visitors an overall view of you as a professional for example, your job role, job functions, educational qualification etc. This information helps recruiters figure out if you might be the correct fit for their company."
    }),
    slides: [
      // Example 1: JD
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            {/* Header */}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.schoolUniversity.topUsLawSchool.mofo", defaultMessage: "Top US Law School" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.dash.mofo", defaultMessage: " – " })}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.degree.jd.mofo", defaultMessage: "Juris Doctor (JD)" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.bar.mofo", defaultMessage: " | " })}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.concentration.corporateSecuritiesLaw.mofo", defaultMessage: "Corporate & Securities Law" })}
            </span>
            <br />
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.bulletSymbol.mofo", defaultMessage: "•" })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.example1.bullet1.prefix.mofo", defaultMessage: " Completed advanced coursework in " }) }
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">{intl.formatMessage({id:"aspire.category.marker.E",defaultMessage:"E"})}</div>
              {intl.formatMessage({id:"aspire.category.certifications.corpLawSecRegMnaCg.mofo",defaultMessage:"corporate law, securities regulation, mergers & acquisitions, and corporate governance."})}
            </span>
            <br />
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.bulletSymbol.mofo", defaultMessage: "•" })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.example1.bullet2.prefix.mofo", defaultMessage: " Served as " })}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">{intl.formatMessage({id:"aspire.category.marker.D",defaultMessage:"D"})}</div>
              {intl.formatMessage({id:"aspire.category.positionOfResponsibility.editorLawReview.mofo",defaultMessage:"Editor, Law Review"})}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.example1.bullet2.suffix.mofo", defaultMessage: ", contributing to publications on regulatory and transactional topics." })}
            <br />
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.bulletSymbol.mofo", defaultMessage: "•" })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.example1.bullet3.prefix.mofo", defaultMessage: " Participated in " })}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">{intl.formatMessage({id:"aspire.category.marker.F",defaultMessage:"F"})}</div>
              {intl.formatMessage({id:"aspire.category.competitions.mootCourt.mofo",defaultMessage:"moot court"})}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.example1.bullet3.middle.mofo", defaultMessage: " and " })}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">{intl.formatMessage({id:"aspire.category.marker.F",defaultMessage:"F"})}</div>
              {intl.formatMessage({id:"aspire.category.competitions.securitiesLawCompetitions.mofo",defaultMessage:"securities law competitions"})}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.example1.bullet3.suffix.mofo", defaultMessage: ", developing advocacy and analytical skills." })}
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id:"aspire.category.schoolUniversity",defaultMessage:"School/University" }), albhabet: intl.formatMessage({ id:"aspire.category.marker.A",defaultMessage:"A" }) },
          { name: intl.formatMessage({ id:"aspire.category.degree",defaultMessage:"Degree" }), albhabet: intl.formatMessage({ id:"aspire.category.marker.B",defaultMessage:"B" }) },
          { name: intl.formatMessage({ id:"aspire.category.concentration",defaultMessage:"Concentration" }), albhabet: intl.formatMessage({ id:"aspire.category.marker.C",defaultMessage:"C" }) },
          { name: intl.formatMessage({ id:"aspire.category.positionOfResponsibility",defaultMessage:"Position of Responsibility" }), albhabet: intl.formatMessage({ id:"aspire.category.marker.D",defaultMessage:"D" }) },
          { name: intl.formatMessage({ id:"aspire.category.certifications",defaultMessage:"Certifications" }), albhabet: intl.formatMessage({ id:"aspire.category.marker.E",defaultMessage:"E" }) },
          { name: intl.formatMessage({ id:"aspire.category.competitions",defaultMessage:"Competitions" }), albhabet: intl.formatMessage({ id:"aspire.category.marker.F",defaultMessage:"F" }) }
        ]
      },
      // Example 2: LLM
      {
        text: (
          <p className="text-normal padding-top-15 line-height-3">
            {/* Header */}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.schoolUniversity.leadingGlobalU.mofo", defaultMessage: "Leading Global University" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.dash.mofo", defaultMessage: " – " })}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.degree.llm.mofo", defaultMessage: "Master of Laws (LLM)" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.bar.mofo", defaultMessage: " | " })}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" })}
              </div>
              {intl.formatMessage({ id: "aspire.category.concentration.internationalBusinessRegLaw.mofo", defaultMessage: "International Business & Regulatory Law" })}
            </span>
            <br />
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.bulletSymbol.mofo", defaultMessage: "•" })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.example2.bullet1.1.mofo", defaultMessage: " Specialized in " })}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">
                {intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" })}
              </div>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.example2.bullet1.2.mofo", defaultMessage: "cross-border transactions, international regulatory frameworks, and comparative corporate law." })}
            </span>
            <br />
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.bulletSymbol.mofo", defaultMessage: "•" })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.example2.bullet2.mofo", defaultMessage: " Conducted research on multijurisdictional compliance and regulatory risk in global enterprises." })}
            <br />
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.bulletSymbol.mofo", defaultMessage: "•" })}
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.example2.bullet3.prefix.mofo", defaultMessage: " Member of the " })}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">{intl.formatMessage({ id: "aspire.category.marker.F", defaultMessage: "F" })}</div>
              {intl.formatMessage({ id: "aspire.category.clubSociety.internationalLawSociety.mofo", defaultMessage: "International Law Society" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.example2.bullet3.suffix.mofo", defaultMessage: ", collaborating with peers from US, EU, and APAC jurisdictions." })}
            <br />
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.bulletSymbol.mofo", defaultMessage: "•" })}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">{intl.formatMessage({ id: "aspire.category.marker.E", defaultMessage: "E" })}</div>
                {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.example2.bullet4.prefix.1.mofo", defaultMessage: " Presented research" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.example2.bullet4.prefix.2.mofo", defaultMessage: " findings at " })}
            <span className="show-category-larger">
              <div className="green-icon-cr cr-icon-width-small text-color-green">{intl.formatMessage({ id: "aspire.category.marker.G", defaultMessage: "G" })}</div>
              {intl.formatMessage({ id: "aspire.category.competitions.intLegalConfForum.mofo", defaultMessage: "international legal conferences and academic forums" })}
            </span>
            {intl.formatMessage({ id: "aspire.samplesMapForInfoCategories.education.example2.bullet4.suffix.mofo", defaultMessage: "." })}
          </p>
        ),
        categories: [
          { name: intl.formatMessage({ id: "aspire.category.schoolUniversity", defaultMessage: "School/University" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.A", defaultMessage: "A" }) },
          { name: intl.formatMessage({ id: "aspire.category.degree", defaultMessage: "Degree" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.B", defaultMessage: "B" }) },
          { name: intl.formatMessage({ id: "aspire.category.concentration", defaultMessage: "Concentration" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.C", defaultMessage: "C" }) },
          { name: intl.formatMessage({ id: "aspire.category.certifications", defaultMessage: "Certifications" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.D", defaultMessage: "D" }) },
          { name: intl.formatMessage({ id: "aspire.category.positionOfResponsibility", defaultMessage: "Position of Responsibility" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.E", defaultMessage: "E" }) },
          { name: intl.formatMessage({ id: "aspire.category.clubSociety", defaultMessage: "Club/Society" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.F", defaultMessage: "F" }) },
          { name: intl.formatMessage({ id: "aspire.category.competitions", defaultMessage: "Competitions" }), albhabet: intl.formatMessage({ id: "aspire.category.marker.G", defaultMessage: "G" }) },
        ]
      },
    ],
    static_categories: {
      left_col: [
        intl.formatMessage({ id: "aspire.category.schoolUniversity", defaultMessage: "School/University" }),
        intl.formatMessage({ id: "aspire.category.positionOfResponsibility", defaultMessage: "Position of Responsibility" }),
        intl.formatMessage({ id: "aspire.category.degree", defaultMessage: "Degree" }),
        intl.formatMessage({ id: "aspire.category.competitions", defaultMessage: "Competitions" }),
      ],
      right_col: [
        intl.formatMessage({ id: "aspire.category.concentration", defaultMessage: "Concentration" }),
        intl.formatMessage({ id: "aspire.category.certifications", defaultMessage: "Certifications" }),
        intl.formatMessage({ id: "aspire.category.clubSociety", defaultMessage: "Club/Society" }),
      ],
    }
  }
});
